<div class="color-chooser">
  {{ 'i18n.control.colorChooser.color' | translate }}:
  <div class="control" cdkOverlayOrigin #root="cdkOverlayOrigin">
    <div (click)="showPalette = true; adaptPaletteHeight()">
      <div id="current-color"
        [style.backgroundColor]="currentColor"
      ></div>
    </div>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="root"
      [cdkConnectedOverlayOpen]="showPalette"
      [cdkConnectedOverlayHasBackdrop]="true"
      (backdropClick)="showPalette = false"
      (attach)="onOverlayAttach()"
      [cdkConnectedOverlayPanelClass]="'palette'"
      [cdkConnectedOverlayWidth]="paletteWidth"
      [cdkConnectedOverlayFlexibleDimensions]="true"
      [cdkConnectedOverlayPositions]="[
        { originX: 'center', originY: 'top',
          overlayX: 'center', overlayY: 'bottom'
        }
      ]"
    >
      <div #wrapper class="colors-wrapper" [style.max-width.px]="paletteWidth"
        [style.max-height.px]="paletteHeight">
        @if (colors.additionalColors.length > 0) {
          <div class="additional-colors colors"
            >
            @for (color of colors.additionalColors; track $index) {
              <div class="color"
                [ngClass]="{'active': color === currentColor}"
                [style.backgroundColor]="color"
                (click)="setColor(color)"
                >
              </div>
            }
            @for (p of phantoms.additionalColors; track $index) {
              <div class="phantom color"
              ></div>
            }
          </div>
        }
        <div class="base-colors colors">
          @for (color of colors.baseColors; track $index) {
            <div class="color"
              [ngClass]="{'active': color === currentColor}"
              [style.backgroundColor]="color"
              (click)="setColor(color)"
              >
            </div>
          }
          @for (p of phantoms.baseColors; track $index) {
            <div class="phantom color"
            ></div>
          }
        </div>
      </div>

      <div class="arrow" [style.left.px]="arrowLeft">
      </div>
    </ng-template>
  </div>
</div>
